import React from 'react';
import Tile from './Tile';

class Tiles extends React.Component {
	render() {
		// Create tile for each item in data array
        // Pass data to each tile and assign a key
        let images = [];
        this.props.data.map((data,index)=>{
            images[index] = {'src': data.image};
        });
		return (
			<div className="tiles">
				{this.props.data.map((data) => {
					return <Tile data={data} key={data.id} imagedata = {images}/>
				})}
			</div>
		);
	}
}

export default Tiles;


// WEBPACK FOOTER //
// ./src/components/Tiles.js